<template>
  <div class="flex items-center justify-between px-6 text-gray-300">
    <a href="https://br.linkedin.com/company/ontickinvest" target="_blank">
      <i v-html="$icons.linkedin"></i>
      <span class="sr-only">LinkedIn</span>
    </a>
    <a href="https://www.instagram.com/ontickinvest/" target="_blank">
      <i v-html="$icons.instagram"></i>
      <span class="sr-only">Instagram</span>
    </a>
    <a
      href="https://www.youtube.com/channel/UCJY1-wTRxB6Jjh70CaftpDw"
      target="_blank"
    >
      <i v-html="$icons.youtube"></i>
      <span class="sr-only">YouTube</span></a
    >
    <a href="https://www.ontick.com.br/blog" target="_blank">
      <i v-html="$icons.blog"></i>
      <span class="sr-only">Blog</span></a
    >
  </div>
</template>

<script>
export default {};
</script>

<style></style>
